module.exports = __webpack_public_path__ + "static/after-sales-banner-en-27619d5eae21795f28f263d2a8335b9f.png";